import MainNav from "@wwg/support-ui/dist/Components/MainNav/MainNav";
import { ENVIRONMENT_CONFIG } from "shared/globals";
import "react-notifications-component/dist/theme.css";
import styles from "./App.module.css";

import React, { Suspense, useState } from "react";
import { ReactNotifications } from "react-notifications-component";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import { useTitle } from "react-use";
import { Auth } from "./shared/@auth/Auth";
import { NavState } from "@wwg/support-ui/dist/Components/Nav/useNavState";

import { CurrentRouteContext } from "shared/@hooks/useCurrentRoute";
import { PageNavState } from "shared/Page/usePageNavState";
import SectionErrorBoundary from "shared/SectionErrorBoundary";
import LoadingPage from "./shared/LoadingPage";
import Marketing from "./Marketing";

const { pageTitle, externalLinks, flags } = ENVIRONMENT_CONFIG;

function App() {
  useTitle(pageTitle);

  const { hasPermission } = Auth.useContainer();
  const { collapsed: navCollapsed, setCollapsed: setMainNavCollapsed } =
    NavState.useContainer();
  const { setCollapsed: setPageNavCollapsed } = PageNavState.useContainer();
  const [currentRoute, setCurrentRoute] = useState();
  const compactNavigationRef = React.useRef(window.innerWidth < 900);

  React.useEffect(() => {
    if (compactNavigationRef.current) {
      setMainNavCollapsed(true);
      setPageNavCollapsed(true);
    }

    const handleResize = () => {
      const isCompact = window.innerWidth < 900;
      if (isCompact && !compactNavigationRef.current) {
        setMainNavCollapsed(true);
        setPageNavCollapsed(true);
      }
      compactNavigationRef.current = isCompact;
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [setMainNavCollapsed, setPageNavCollapsed]);

  return (
    <Router>
      <ReactNotifications />
      <CurrentRouteContext.Provider value={{ currentRoute, setCurrentRoute }}>
        <div
          className={styles.layout}
          style={{ "--main-nav-width": navCollapsed ? "50px" : "260px" }}
        >
          <MainNav
            fetchManagementTeamNotification={
              flags.fetchManagementTeamNotification &&
              hasPermission("management-team.*")
            }
            auth={Auth}
            navCollapsed={navCollapsed}
            externalLinks={externalLinks}
            currentRoute={currentRoute}
          />

          <main className={styles.main}>
            <SectionErrorBoundary>
              <Suspense fallback={<LoadingPage />}>
                <Switch>
                  {hasPermission("marketing.*") && (
                    <Route path="/marketing">
                      <Marketing />
                    </Route>
                  )}

                  <Route path="*">
                    {hasPermission("marketing.*") ? (
                      <Redirect to="/marketing" />
                    ) : (
                      <Marketing />
                    )}
                  </Route>
                </Switch>
              </Suspense>
            </SectionErrorBoundary>
          </main>
        </div>
      </CurrentRouteContext.Provider>
    </Router>
  );
}
export default App;

function NotFound() {
  return (
    <div className={styles.notFound}>
      <h1>Welcome to WWG Support</h1>
      <p>Choose a section on the left sidebar to get started.</p>
    </div>
  );
}
